<template>
  <el-row class="about_us_wrap" type="flex" >
    <el-col class="about_us_left" span="6"> >
      <el-card class="about_us_left_card" shadow="always">
        <h2>企业简介</h2>
        <div style="width: 20%; height: 4px; background-color:#003366 " class="about_us_left_card_line" ></div>
        <p>
          专注整合优质教育资源，致力于发展职业教育。涵盖中考、高职高考、高考、专升本、考研、国际教育、高端就业等多个领域。经过10年发展，旗下包含多个子公司。
        </p>
      </el-card>
    </el-col>
    <el-col   :span="19" class="about_us_right" >
      <el-col style="width: 50px; height: 100%"></el-col>
      <el-col class="about_us_right_image_mask about_us_right_item"
           v-for="(item, index) in cardList"
           :key="index"

      >
<!--        <div ><img :src="item.icon" alt=""  style="color: #fff" /></div>-->
        <div class="about_us_right_item_svg"><SvgIcon :name="item.icon" class="svg-icon"  /></div>
        <div class="about_us_right_item_number">
          <CountTo :start-val="0" :end-val="item.number" :duration="2500" class="count-number"></CountTo>+
        </div>
        <div class="about_us_right_item_tit">{{item.tit}}</div>
      </el-col>

    </el-col>

  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: "users",
          number: 100,
          tit: '所合作院校'
        },
        {
          icon: 'umbrella',
          number: 12000,
          tit: '个性化服务'
        },
        {
          icon: 'star',
          number: 1000,
          tit: '国际留学'
        },
        {
          icon: 'bulding-line',
          number: 30000,
          tit: '求学学生'
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>

.about_us_wrap {
  display: flex;
  width: 100%;
  height: 540px;
  background-color: #003366;
  .about_us_left {
    background-color: #003366;
    .about_us_left_card {
      width: 280px;
      height: 90%;
      margin-left: 250px;
      color: #003366;
      font-size: 20px;
      font-weight: bold;
      position: absolute;
      z-index: 2;


      .about_us_left_card_line {
        margin-top: 10px;
        margin-bottom: 40px;
      }
      p {
        font-size: 15.5px;
        font-weight: normal;
        color: #282828;
        line-height: 26px;

      }
    }
  }

  .about_us_right {
    background-image: url("../../assets/img/about_us/about_us.jpg");
    background-size: cover;
    //position: absolute;
    z-index: 1;
    backdrop-filter: blur(4px);
    //padding-right: 100px;
    marggin-left: 100px;

    .about_us_right_image_mask {

      width: 100%;
      height: 100%;
      background: rgb(255, 255, 255,0.7);
    }

    .about_us_right_item {
      width: 300px;
      text-align: center;

      .about_us_right_item_svg {
        width: 100px;
        height: 100px;
        margin-left: 102px;
        margin-top: 100px;

        padding-top: 20px;
        background-color: #003366;

        .svg-icon {
          width: 50px;
          height: 50px;
          color: #ffffff;

        }
      }
      .about_us_right_item_number {
        margin-top: 20px;
        font-size: 50px;
        font-weight: bold;
        color: #003366;
      }
      .about_us_right_item_tit {
        font-size: 18px;
        font-weight: bold;
        margin-top: 20px;
      }
    }

  }
}


.core_one_wrap {
  height: 440px;

  justify-content: center;
  text-align: left;
  margin-bottom: 30px;
  background: #282828;
  padding-top: 60px;
  padding-bottom: 50px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }


  .one_left {
    width: 25%;
    height: 100%;
    margin-right: 5%;
    @media screen and (max-width: 768px) {
      width: 70%;
    }
    img{
      width: 100%;
    }
  }
}
</style>